import { gql } from '@apollo/client';
import { useFetchCallback } from './useFetchCallback';

const GET_CLIENT_PROFIT_PORTFOLIO = gql`
  query GetClientProfitPortfolio {
    getClientProfitPortfolio {
      fmtMarketValue
      marketValue
      fmtNetChange
      netChange
      fmtCapitalAppreciation
      capitalAppreciation
      fmtProfitPercent
      profitPercent
    }
  }
`;
const GET_CLIENT_PROFIT_PORTFOLIO_BACKUP = gql`
  query GetClientProfitPortfolioBackup {
    getClientProfitPortfolioBackup {
      fmtMarketValue
      marketValue
      fmtNetChange
      netChange
      fmtCapitalAppreciation
      capitalAppreciation
      fmtProfitPercent
      profitPercent
    }
  }
`;

export const useGetClientProfitPortfolioWithFallback = () => {
  return useFetchCallback(GET_CLIENT_PROFIT_PORTFOLIO, GET_CLIENT_PROFIT_PORTFOLIO_BACKUP, {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  });
};

/* export const useGetClientProfitPortfolio = () => {
  return useQuery(GET_CLIENT_PROFIT_PORTFOLIO, {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  });
}; */
